module.exports = __webpack_public_path__ + "static/media/top-img_5_mob@2x.6d971bb8.png";